import { DemInfos } from "./dem.infos";
import { FetchResult } from "../io";
export class DemTileWebClient {
    constructor(name, elevationSrc, normalSrc) {
        this._zindex = 0;
        this._name = name;
        this._elevationsDataSource = elevationSrc;
        this._normalsDataSource = normalSrc;
    }
    get name() {
        return this._name;
    }
    get zindex() {
        return this._zindex;
    }
    set zindex(v) {
        this._zindex = v;
    }
    get metrics() {
        return this._elevationsDataSource.metrics;
    }
    async fetchAsync(request, env, ...userArgs) {
        const requests = [];
        requests.push(this._elevationsDataSource.fetchAsync(request, env, ...userArgs));
        if (this._normalsDataSource) {
            requests.push(this._normalsDataSource.fetchAsync(request, env, ...userArgs));
        }
        const results = await Promise.allSettled(requests);
        let elevations = null;
        let normals = null;
        if (results[0].status == "fulfilled") {
            elevations = results[0].value.content;
        }
        else {
            throw new Error(results[0].reason);
        }
        if (elevations == null) {
            return new FetchResult(request, null, userArgs);
        }
        if (results.length > 1) {
            if (results[1].status == "fulfilled") {
                normals = results[1].value.content;
            }
        }
        if (normals == null) {
            const s = this.metrics.tileSize;
            normals = this.computeNormals(elevations, s, s);
        }
        const result = new FetchResult(request, new DemInfos(elevations, normals), userArgs);
        result.ok = true;
        return result;
    }
    computeNormals(positions, w, h) {
        const normals = new Uint8ClampedArray(w * h * 3);
        const indices = [0, 3, 6, 15, 24, 21, 18, 9];
        let i = 0;
        for (let row = 0; row < w; row++) {
            for (let col = 0; col < h; col++) {
                let nx = 0;
                let ny = 0;
                let nz = 0;
                let nn = 0;
                const v = this.getNormalsWindows(positions, row, col, w, h);
                let k = indices[0];
                let a1 = v[k++];
                let a2 = v[k++];
                let a3 = v[k];
                for (let i = 1; i < indices.length; i++) {
                    k = indices[i];
                    const b1 = v[k++];
                    const b2 = v[k++];
                    const b3 = v[k];
                    if (a3 !== undefined && b3 !== undefined) {
                        const na = a2 * b3 - a3 * b2;
                        const nb = a3 * b1 - a1 * b3;
                        const nc = a1 * b2 - a2 * b1;
                        nx += na;
                        ny += nb;
                        nz += nc;
                        nn++;
                    }
                    a1 = b1;
                    a2 = b2;
                    a3 = b3;
                }
                const x = nx / nn;
                const y = ny / nn;
                const z = nz / nn;
                const l = Math.sqrt(x * x + y * y + z * z);
                const R = ((x / l + 1) / 2) * 255;
                const G = ((y / l + 1) / 2) * 255;
                const B = (z / l) * 127 + 128;
                normals[i++] = R;
                normals[i++] = G;
                normals[i++] = B;
            }
        }
        return normals;
    }
    getNormalsWindows(positions, i, j, w, h) {
        let index = (i * w + j) * 3;
        const xref = positions[index++];
        const yref = positions[index++];
        const zref = positions[index];
        const windows = new Array(27);
        const startRow = i - 1;
        const endRow = i + 1;
        const startCol = j - 1;
        const endCol = j + 1;
        let k = 0;
        for (let row = startRow; row <= endRow; row++) {
            const offset = row * w;
            for (let col = startCol; col <= endCol; col++) {
                index = (offset + col) * 3;
                let dx = col < 0 ? undefined : col >= w ? undefined : positions[index] - xref;
                let dy = row < 0 ? undefined : row >= h ? undefined : positions[index + 1] - yref;
                let dz = dx === undefined || dy === undefined ? undefined : positions[index + 2] - zref;
                windows[k++] = dx;
                windows[k++] = dy;
                windows[k++] = dz;
            }
        }
        return windows;
    }
}
//# sourceMappingURL=dem.tileclient.js.map